import api from "../api";

export default class RedefinePasswordApi {
  verifyEmail(email: string) {
    return api.post("/users/password/verify_email", {
      email: email,
    });
  }

  verifyOtp(email: string, otp: string) {
    return api.post("/users/password/verify_otp", {
      email: email,
      otp: otp,
    });
  }

  resetPassword(password: string, email: string, resetOtp: string) {
    return api.post("/users/password/reset_password", {
      password: password,
      email: email,
      reset_otp: resetOtp,
    });
  }
}
